export enum SewageTypeEnum {
  Classic = 'sewage_classic',
  Premium = 'sewage_premium',
}
